const FooterChatIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    fill="none"
    viewBox="0 0 32 32"
  >
    <circle className="fill-(--footer-icon)" cx="16" cy="16" r="16"></circle>
    <path
      className="fill-(--path-footer-icon)"
      fillRule="evenodd"
      d="M23.858 17.47c0 1.282-1.027 2.327-2.29 2.327H14.34c-.022 0-.042.01-.064.011a.52.52 0 00-.218.074c-.02.013-.042.016-.06.03l-3.039 2.328.037-1.853-.002-.006.002-.006c0-.037-.014-.07-.02-.104-.008-.038-.009-.079-.024-.116-.014-.038-.042-.067-.063-.101-.02-.027-.034-.058-.056-.083-.028-.029-.064-.047-.098-.069-.028-.02-.05-.044-.081-.057-.034-.015-.074-.017-.11-.025-.036-.008-.069-.022-.105-.023H10.426c-1.262 0-2.29-1.045-2.29-2.327v-5.987c0-1.282 1.028-2.327 2.29-2.327h11.141c1.264 0 2.291 1.045 2.291 2.327v5.987zM21.57 8H10.429C8.538 8 7 9.563 7 11.484v5.987c0 1.718 1.235 3.142 2.85 3.423L9.8 23.41a.58.58 0 00.31.526.56.56 0 00.603-.053l3.822-2.928h7.035c1.891 0 3.43-1.564 3.43-3.484v-5.987C25 9.564 23.461 8 21.57 8z"
      clipRule="evenodd"
    ></path>
  </svg>
)

export { FooterChatIcon }
